module.exports = __webpack_public_path__ + "static/media/8.ea392339.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格未选中态/8.png
// module id = 948
// module chunks = 0